class TableHelper {
  static getField = <T,>(value: T, field: keyof T): string =>
    value == null ? '' : value[field] == null ? '' : value[field] + ''

  static stringCompare =
    <T,>(field: keyof T) =>
    (a: T, b: T) => {
      let fieldA = TableHelper.getField(a, field)
      let fieldB = TableHelper.getField(b, field)
      return fieldA.localeCompare(fieldB) || 0
    }

  static dateCompare =
    <T,>(field: keyof T) =>
    (a: T, b: T) => {
      const dateA = a[field] ? new Date(a[field] as any).getTime() : 0
      const dateB = b[field] ? new Date(b[field] as any).getTime() : 0
      return dateA - dateB
    }
}

export default TableHelper
